import { jsx as n } from "react/jsx-runtime";
import { useMemo as s } from "react";
import a from "../RadioInput/index.js";
import l from "../../hooks/useTranslation.js";
import { stringLabelSelector as r, booleanValueSelector as i } from "../../utils/selectors.js";
const m = "common", c = {
  yesLabel: "Yes",
  noLabel: "No"
}, p = {
  namespace: m,
  strings: c
};
function g(o) {
  const e = l(p), t = s(
    () => [
      { value: !0, label: e.yesLabel },
      { value: !1, label: e.noLabel }
    ],
    [
      e.yesLabel,
      e.noLabel
    ]
  );
  return /* @__PURE__ */ n(
    a,
    {
      ...o,
      options: t,
      keySelector: i,
      labelSelector: r
    }
  );
}
export {
  g as default
};
